import Floor from "./floor-body";

export default Floor;

